import React, {useState} from "react";
import {useCustomerContext} from "../customer/CustomerContextProvider/CustomerContextProvider";
import {useForm} from "react-hook-form";
import {Trans, useTranslation} from "react-i18next";
import {CustomerFactory} from "@connox/typescript-library";
import {getShopId} from "../lib/getShopId";
import {emailRegExp} from "../lib/ModalWindow/ForgotPasswordModal";
import styles from "./NewsletterRegistrationFooterBlock.module.scss";
import Spinner from "../utils/loader/Spinner";

const NewsletterRegistrationFooterBlock: React.FC = () => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation();
  const [successState, setSuccessState] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: {errors},
    trigger,
  } = useForm<{email: string}>({
    mode: "onSubmit",
    defaultValues: {
      email: customer.email ?? "",
    },
  });

  const onSubmit = handleSubmit((data: {email: string}) => {
    setIsLoading(true);
    void trigger();
    void CustomerFactory.createOrUpdateCustomer(getShopId(), {email: data.email, newsletterFlag: true}).then(() => {
      setCustomerEmail(data.email);
      setSuccessState(true);
      setIsLoading(false);
    });
  });

  const resendEmail = () => setSuccessState(false);

  const Image = () => (
    <div className={styles.patternImage}>
      <img
        src={"/media/Newsletter/Newsletteranmeldung-788x450.jpg"}
        alt={t("Im Newsletter über Neugkeiten, Trends und Angebote erfahren")}
      />
    </div>
  );

  return (
    <div className={styles.wrapper}>
      <Image />
      <div className={styles.patternContent}>
        {successState && (
          <React.Fragment>
            <h2>{t("Fast geschafft!")}</h2>
            <p>
              <Trans i18nKey="CallToConfirmNewsletter" values={{customerEmail}}>
                Bitte bestätigen Sie Ihre Anmeldung über den Link in der E-Mail, die wir an
                <strong>{{customerEmail}}</strong> gesendet haben.
              </Trans>
            </p>
            <p>
              <Trans i18nKey="ResendMail">
                Wenn Sie keine E-Mail von uns erhalten haben, lassen Sie sich{" "}
                <span className={styles.resendLink} onClick={resendEmail}>
                  eine neue E-Mail zuschicken
                </span>
                .
              </Trans>
            </p>
          </React.Fragment>
        )}

        {!successState && (
          <React.Fragment>
            <h2>{t("Der Connox Newsletter")}</h2>
            <p className={styles.subtitle}>
              <Trans i18nKey="JetztAnmelden">
                Jetzt anmelden und 12 %-Willkommensrabatt sichern<sup>1</sup>. Freuen Sie sich auf viele Vorteile!
              </Trans>
            </p>
            <form className={styles.patternForm} onSubmit={onSubmit}>
              <span className={styles.hasError}>{errors.email && errors.email.message}</span>
              <div className={styles.formRow}>
                <input
                  type="email"
                  className={`${styles.input} ${errors.email ? styles.invalid : ""}`}
                  placeholder={t("Ihre E-Mail Adresse")}
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: emailRegExp,
                      message: t("Invalid email address"),
                    },
                  })}
                />
                <button className={styles.submitBtn} type="submit">
                  {isLoading ? <Spinner /> : <>{t("Jetzt abonnieren")}</>}
                </button>
              </div>
            </form>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default NewsletterRegistrationFooterBlock;
